import type { CreditUsageType } from './types/Credits';
import type { ModelForJobTypeTeaser, SimulationJobType } from './types/Job';

export type CreditBalanceChangedPayload = {
    type: CreditUsageType;
    amount: number;
};

export type WireSizingChargedPayload = {
    projectId: string;
};

export type SimulationChangedPayload = { diagramId: string; type: SimulationJobType } & (
    | { action: 'created' | 'updated'; doc: ModelForJobTypeTeaser<SimulationJobType> }
    | { action: 'deleted'; id: string }
);

enum WebSocketEvent {
    USER_REFRESH_NOTIFICATIONS = 'user:refresh-notifications',
    USER_RECEIVE_NOTIFICATION = 'user:receive-notification',

    INTERCOM_REFRESH_COMPONENT_CHANNELS = 'intercom:refresh-component-channels',
    INTERCOM_REFRESH_COMPANY_CHANNELS = 'intercom:refresh-company-channels',
    INTERCOM_REFRESH_PROJECT_CHANNELS = 'intercom:refresh-project-channels',
    INTERCOM_REFRESH_CHANNEL_MESSAGES = 'intercom:refresh-channel-messages',

    PROJECT_REFRESH_CHAT_CHANNELS = 'project:refresh-chat-channels',
    PROJECT_REFRESH_CHAT_MESSAGES = 'project:refresh-chat-messages',
    PROJECT_REFRESH_ACCESS_REQUESTS = 'project:refresh-access-requests',
    PROJECT_REFRESH_COLLABORATORS = 'project:refresh-collaborators',
    PROJECT_REFRESH_USERS = 'project:refresh-users',

    DIAGRAM_TRANSACTIONS = 'diagram:transactions',
    DIAGRAM_TRANSACTION = 'diagram:transaction',
    DIAGRAM_REFRESH_AI_CONVERSATION = 'diagram:refresh-ai-conversation',
    DIAGRAM_REFRESH_COMMENTS = 'diagram:refresh-comments',
    DIAGRAM_REFRESH_SIMULATIONS = 'diagram:refresh-simulations',
    DIAGRAM_REFRESH_JOB_LOGS = 'diagram:refresh-job-logs',
    DIAGRAM_WIRE_SIZING_CHARGED = 'diagram:wire-sizing-charged',

    TEAM_CREDIT_BALANCE_CHANGED = 'team:credit-balance-changed',
}

export { WebSocketEvent };
